export default "__VITE_ASSET__CAS_q3sU__"